import React, { useState, useEffect } from 'react';
import { LARGE_DEVICES } from 'seduo-ui/constants';
import withSizes from 'react-sizes';
const AdditionalMenu = ({ actionButton, links, isMobile }) => {
    const [activeLinks, setActiveLinks] = useState('');
    useEffect(() => {
        let intersectedElements = {};
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(({ isIntersecting, intersectionRatio, target: { id } }) => {
                intersectedElements[id] = isIntersecting ? intersectionRatio : 0;
            });
            let activeLinkRatio = 0;
            let activeLinkId = '';
            Object.keys(intersectedElements).forEach((key) => {
                if (intersectedElements[key] > activeLinkRatio) {
                    activeLinkRatio = intersectedElements[key];
                    activeLinkId = key;
                }
            });
            setActiveLinks(activeLinkId);
        }, {
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        });
        const elements = links.map((link) => document.getElementById(link.id)).filter(Boolean);
        elements.forEach((element) => observer.observe(element));
        return () => elements.forEach((element) => observer.unobserve(element));
    }, []);
    const handleClick = (event, id) => {
        event.preventDefault();
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
            });
        }
    };
    return (<div className="position-relative mw-100">
            <div className="additional-menu">
                {!isMobile && actionButton}
                <div className={`d-inline-flex ${!isMobile ? 'mx-8' : ''}`}>
                    {links.map(({ id, title }) => {
            return (<a key={id} className={`link-reset py-5 additional-menu__link ${activeLinks === id ? 'additional-menu__link--active' : ''}`} onClick={(event) => handleClick(event, id)} href={`#${id}`}>
                                {title}
                            </a>);
        })}
                </div>
            </div>
        </div>);
};
const mapSizesToProps = ({ width }) => ({
    isMobile: width < LARGE_DEVICES,
});
export default withSizes(mapSizesToProps)(AdditionalMenu);
